import { render, staticRenderFns } from "./AddAdvertisement.vue?vue&type=template&id=de16c64c&"
import script from "./AddAdvertisement.vue?vue&type=script&lang=js&"
export * from "./AddAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports